export const loginiam = {
    emergencyStopMsg: 'The site is temporarily unavailable',
    terminatedMsg: 'Invalid account'
}
